/** Time left on the customer's card hold (step 10, Rod 2026-09-30): amber under 48 h, red under 24 h. */
export type HoldUrgency = 'red' | 'amber' | 'normal';

const HOUR_MS = 3_600_000;

export function holdTimeLeft(expiresAt: string | null, now: Date): { label: string; urgency: HoldUrgency } | null {
  if (!expiresAt) return null;
  const ms = new Date(expiresAt).getTime() - now.getTime();
  if (ms <= 0) return { label: 'Expired', urgency: 'red' };
  const hours = Math.floor(ms / HOUR_MS);
  const label = hours >= 48 ? `${Math.floor(hours / 24)}d ${hours % 24}h` : hours >= 1 ? `${hours}h` : `${Math.max(1, Math.floor(ms / 60_000))}m`;
  return { label, urgency: ms < 24 * HOUR_MS ? 'red' : ms < 48 * HOUR_MS ? 'amber' : 'normal' };
}

export const URGENCY_COLORS: Record<HoldUrgency, { fg: string; bg: string }> = {
  red: { fg: '#b42318', bg: '#fef3f2' },
  amber: { fg: '#b54708', bg: '#fffaeb' },
  normal: { fg: '#344054', bg: '#f2f4f7' },
};
